import React from 'react';
export var RenderIdaVuelta = function () {
    return (React.createElement("div", null,
        React.createElement("h2", null,
            React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } }, 'IDA')),
        React.createElement("h2", null,
            React.createElement("p", { style: { textAlign: 'center' } }, 'VUELTA'))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/IdaVuelta.tsx
// module id = 489
// module chunks = 0